module.exports = __webpack_public_path__ + "static/SLFC-finalCover-81bcabebbe20f2be4914838497e3eb32.jpg";